import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "stretch",
    },
    blurred: {
        width: "100%",
        height: "100%",
        filter: "blur(2px) grayscale(80%)",
    },
});

interface BlurLoaderProps extends WithStyles<typeof styles> {
    children?: React.ReactNode;
    isLoading?: boolean;
}

export const BlurLoader = withStyles(styles, { name: "BlurLoader" })(
    (props: BlurLoaderProps) => {
        const { classes, children, isLoading } = props;

        const classNameProp = classnames(classes.root, {
            [classes.blurred]: isLoading,
        });

        return <div className={classNameProp}>{children}</div>;
    }
);
